'use client'

import { ErrorComponent } from 'monitoring/components/ErrorComponent/ErrorComponent'

export default function GlobalError({
	error,
	reset,
}: {
	readonly error: Error & { digest?: string }
	readonly reset: () => void
}) {
	return (
		<html lang='en'>
			<body>
				<ErrorComponent error={error} reset={reset} />
			</body>
		</html>
	)
}
